import { connect } from 'react-redux'

import {
  europeCollectData,
  collectDataReset,
  europePayment,
  russiaCollectData,
  russiaPayment,
} from 'actions'
import { getSales, getCurrentLocale } from 'selectors'

import CartFormCommon from './CartFormCommon'

function mapStateToProps(state) {
  return {
    countries: state.localization.countries,
    sales: getSales(state),
    locale: getCurrentLocale(state),
  }
}

const mapDispatchToProps = {
  europeCollectData,
  collectDataReset,
  europePayment,
  russiaCollectData,
  russiaPayment,
}

export default connect(mapStateToProps, mapDispatchToProps)(CartFormCommon)
